/* eslint-disable */
import FlightFareBox from './FlightFareBox'
import FilteringPanelByAirline from './FilteringPanelByAirline'
import FilteringPanelByOtherValues from './FilteringPanelByOtherValues'
import helper from '../helper'

const SearchResultList=  {
    created(){

        if(this.AdultCount==0){
            this.adult=this.$store.state.searchBoxValues.passengerCountByPax.adult;
            this.child=this.$store.state.searchBoxValues.passengerCountByPax.child;
            this.infant=this.$store.state.searchBoxValues.passengerCountByPax.infant;
            this.student=this.$store.state.searchBoxValues.passengerCountByPax.student;//To be written later.
        }else{
            this.adult=this.AdultCount;
            this.child=this.ChildCount;
            this.infant=this.InfantCount;
            this.student=this.StudentCount;
        }
        setInterval(() => {
          let trigger = this.modifiedFlightFares.length
        }, 1000);
    },
    props:[
        'FlightFares',
        'AdultCount',
        'ChildCount',
        'InfantCount',
        'StudentCount',
        'SelectedAirlines',
        'RouteIndicator',
        'TotalPriceFilter',
        'OutboundDepartureTimeFilter',
        'ReturnDepartureTimeFilter',
        'FlightDuration',
        'SearchId'
    ],
    computed:{
        resultDisplayTrigger1(){
          return this.finishFaresMod
        },
        routeIndicator(){
            return this.RouteIndicator==null?'11':this.RouteIndicator;
        },
        totalPriceFilter(){
            return this.TotalPriceFilter==null? [3000,100000000]:this.TotalPriceFilter;
        },
        modifiedFlightFares(){
            return this.getModifiedFlightFares(this.FlightFares);
        },
        outboundDepartureTimeFilter(){
            return this.OutboundDepartureTimeFilter==null? ['00:00','23:59']:this.OutboundDepartureTimeFilter;
        },
        returnDepartureTimeFilter(){
            return this.ReturnDepartureTimeFilter==null? ['00:00','23:59']:this.ReturnDepartureTimeFilter;
        },
        flightDurationFilter(){
            return [0,this.FlightDuration==null?30000:this.FlightDuration];
        },
    },
    data(){
        return {
            sheet:false,
            flightFares:this.FlightFares,
            helper:helper,
            adult:0,
            child:0,
            infant:0,
            student:0,
            finishFaresMod:0
        }
    },
    components:{
        FlightFareBox,
        FilteringPanelByAirline,
        FilteringPanelByOtherValues
    },
    methods:{
        updatePassengerCount(){
          this.adult=this.$store.state.searchBoxValues.passengerCountByPax.adult;
          this.child=this.$store.state.searchBoxValues.passengerCountByPax.child;
          this.infant=this.$store.state.searchBoxValues.passengerCountByPax.infant;
          this.student=this.$store.state.searchBoxValues.passengerCountByPax.student;
        },
        reorderFlightGroups(pFlights){
            let DepartsReturns = [pFlights.FilteredDepartures,pFlights.FilteredReturns];

            DepartsReturns.forEach((trip,index) => {
                let lnq = new this.$linq(trip);
                
                let lstGrp = lnq.distinctBy(f=>f.Flight.GroupFlightID)
                    .select(function(f) {return {
                        grpId:f.Flight.GroupFlightID,
                        jrnyTm:f.Flight.JrnyTm
                        };}).toArray();

                let ordNo = 1;
                lstGrp.forEach(g => {
                    let flightsOfGrp = lnq.where(f=>f.Flight.GroupFlightID==g.grpId);
                    flightsOfGrp = flightsOfGrp.orderBy(f=>parseInt(f.Flight.StartDt)).thenBy(f=>parseInt(f.Flight.StartTm));
                    g.startDate = parseInt(flightsOfGrp.toArray()[0].Flight.StartDt);
                    g.startTime = parseInt(flightsOfGrp.toArray()[0].Flight.StartTm);
                });           

                lstGrp = new this.$linq(lstGrp).orderBy(g=>g.startDate).thenBy(g=>g.startTime).thenBy(g=>g.jrnyTm).toArray();

                lstGrp.forEach(g => {
                    let flightsOfGrp = lnq.where(f=>f.Flight.GroupFlightID==g.grpId);
                    flightsOfGrp = flightsOfGrp.orderBy(f=>parseInt(f.Flight.StartDt)).thenBy(f=>parseInt(f.Flight.StartTm));
                    flightsOfGrp.toArray().forEach(f => {
                        f.Flight.ordering = ordNo;
                        ordNo++;
                    });
                });

                if (index==0){
                    pFlights.FilteredDepartures = lnq.orderBy(f=>f.Flight.ordering).toArray();
                }else {
                    pFlights.FilteredReturns = lnq.orderBy(f=>f.Flight.ordering).toArray();
                }
                

            });
            return pFlights
        },

        isMobile(){
            return 'md,lg,xl'.indexOf(this.$vuetify.breakpoint.name)<0;
        },
        isSelected(airlineCode){
            if (this.SelectedAirlines==null){
                return true;
            }else{
                return this.SelectedAirlines.indexOf (airlineCode)>=0;
            }
        },
        flightFareRouteMatched(ff){
            var departures = new this.$linq(ff.Departures);
            var returns = new this.$linq(ff.Returns).toArray();
            
            departures = departures.union(returns);
            
            var grpFlights = departures.select(f=>{
                return {id:f.Flight.GroupFlightID}}).groupBy(f=>f.id).select(f=>{return{id:f.key,count:f.values.length}});
            var tCount1= grpFlights.where(f=>{return f.count==1}).toArray().length>0? 1:0;
            var tCount2= grpFlights.where(f=>{return f.count>1}).toArray().length>0? 1:0;

            var rslt = false;
            if (this.routeIndicator=="11"){
                rslt = tCount1==1 || tCount2==1;
            }else {
                rslt = this.routeIndicator== tCount1+ '' + tCount2
            }
            return rslt;
        },
        totalPriceMatched(ff){
            var totalPrice = this.getTotalFare(ff);
            var matched = (this.totalPriceFilter[0]<=totalPrice && 
            this.totalPriceFilter[1]>=totalPrice);
            return matched;
        },
        getTotalFare(ff){     
          this.updatePassengerCount(); 
            var adtFare = ff.AdultFare * this.adult;
            var cnnFare = ff.ChildFare * this.child;
            var infFare = ff.InfantFare * this.infant;
            var stuFare = ff.StudentFare * this.student;
            var totalPrice = adtFare + cnnFare + infFare + stuFare;
            //this.departureTimeMatched();
            return totalPrice;
        },
        getModifiedFlightFares(ff){
            var flightFares = ff;

            var fncTimeMatched = (flight,flt)=>{
                var timeSlots = new this.$linq(this.helper.dateAndTime.getTimeSlots(1,1));
                var filterValues = [];
                filterValues[0] = timeSlots.where(s=>s.text==flt[0]).toArray()[0];
                filterValues[1] = timeSlots.where(s=>s.text==flt[1]).toArray()[0];
                var flightDepartureTime = timeSlots.where(s=>s.text==flight.FlightGroupDepartureTime).toArray()[0];
                var rslt = (flightDepartureTime.key>=filterValues[0].key && flightDepartureTime.key<=filterValues[1].key);
                flight.DepartureTimeMatched = rslt;
                
                return rslt;                      
            }
            
            var fnc = (f,g,t,h,flt)=>{
                    if (g!=f.Flight.GroupFlightID){
                        g = f.Flight.GroupFlightID;
                        t = f.Flight.StartTm;
                        f.Flight.FlightGroupDepartureTime = h.dateAndTime.getFourDigitTimeWithColon(t);
                    }else{
                        f.Flight.FlightGroupDepartureTime = h.dateAndTime.getFourDigitTimeWithColon(t);
                    }    
                    f.Flight.DepartureTimeMatched = fncTimeMatched(f.Flight,flt)
                    return [g,t];           
            };

//********************************************* */
            if (!flightFares) return;
            flightFares.forEach(flights => {
                var tGroupFlightId = "";
                var tDepartureTime = "";  
                var tGroupFlightId2 = "";
                var tDepartureTime2 = "";    
                
                flights.Departures.forEach(item=>{
                    var gt = fnc(item,tGroupFlightId,tDepartureTime,this.helper,this.outboundDepartureTimeFilter);
                    tGroupFlightId = gt[0];
                    tDepartureTime = gt[1];
                });

                flights.FilteredDepartures = new this.$linq(flights.Departures).where (f=>f.Flight.DepartureTimeMatched==true).toArray();
                flights.FilteredDepartures = new this.$linq(flights.FilteredDepartures)
                    .where (f=> (parseInt(f.Flight.JrnyTm)>= this.flightDurationFilter[0]) && (parseInt(f.Flight.JrnyTm) <= this.flightDurationFilter[1])).toArray();

                if (flights.Returns!=null&&flights.Returns.length>0){
                    flights.Returns.forEach(item=>{
                        var gt = fnc(item,tGroupFlightId2,tDepartureTime2,this.helper,this.returnDepartureTimeFilter);
                        tGroupFlightId2 = gt[0];
                        tDepartureTime2 = gt[1];                        
                    });     
                    flights.FilteredReturns = new this.$linq(flights.Returns).where (f=>f.Flight.DepartureTimeMatched==true).toArray();      
                    flights.FilteredReturns = new this.$linq(flights.FilteredReturns)
                    .where (f=>(parseInt(f.Flight.JrnyTm)>= this.flightDurationFilter[0]) && (parseInt(f.Flight.JrnyTm) <= this.flightDurationFilter[1])).toArray();      
                }
            });
            var newFlightFares = new this.$linq(flightFares).where(f=>
                (f.FilteredDepartures!=null&&f.FilteredDepartures.length>0)
                && (f.Returns!=null&&f.Returns.length>0? (f.FilteredReturns!=null&& f.FilteredReturns.length>0):true)
            ).toArray();
            this.finishFaresMod++
            return newFlightFares;
            //return flightFares;
        },
        departureTimeMatched(){
            var timeSlots = new this.$linq(this.helper.dateAndTime.getTimeSlots(1,30));
            //var timeSlotIndex = timeSlots.where (t=>t.)
        }      
    }
}

export default SearchResultList;